import React from "react";
import { ClockHistory } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import LongCooking from "@/../public/images/icons/long_cooking.svg";
import { Image } from "react-bootstrap";

type CookingTimeBadgeProps = {
  cookingTimeText?: string | null;
  className?: string;
  iconClassName?: string;
  showIcon?: boolean;
  isLongCookingTime: boolean;
};

export const CookingTimeBadge = ({
  cookingTimeText,
  className = "fs-14-18",
  iconClassName = "fs-14-18",
  showIcon = true,
  isLongCookingTime = false,
}: CookingTimeBadgeProps) => {
  const { t } = useTranslation();

  const trimmedCookingTimeText = cookingTimeText?.trim() ?? "";
  const normalizedCookingTimeText = trimmedCookingTimeText.toLowerCase();
  const hasCookingTimeText = trimmedCookingTimeText.length > 0;

  if (!hasCookingTimeText && !isLongCookingTime) return null;

  const isMoreThanOneHour = normalizedCookingTimeText === "1hour";

  return (
    <div
      className={`d-inline-flex align-items-center gap-1 lh-1 ${className ? className : ""}`}
    >
      {hasCookingTimeText ? (
        <>
          {showIcon ? <ClockHistory className={iconClassName} /> : null}
          {isMoreThanOneHour ? (
            <span>{t("more 1 hour")}</span>
          ) : (
            <span>
              {trimmedCookingTimeText} {t("min")}
            </span>
          )}
        </>
      ) : null}
      {isLongCookingTime && (
        <>
          <Image
            src={LongCooking}
            className="d-inline-block d-md-none"
            width={14}
            height={14}
          />
          <Image
            src={LongCooking}
            className="d-none d-md-inline-block"
            width={17}
            height={17}
          />
        </>
      )}
    </div>
  );
};
